export default {
  isInWeixin: function () {
    const ua = window.navigator.userAgent
    if (ua.match(/MicroMessenger/i)) {
      return true
    } else {
      return false
    }
  },
  shareInWeixin: function (params) {
    if (!this.isInWeixin()) return
    const defaultTitle = '极客邦科技'
    const defaultCover = 'http://res001.geekbang.org/static/www/img/favicon-96x96.8e64510.png'
    window.wx.ready(() => {
      window.wx.onMenuShareTimeline({
        title: params.timelineTitle || defaultTitle,
        link: params.url || window.location.href,
        imgUrl: params.imgUrl || defaultCover
      })
      window.wx.onMenuShareAppMessage({
        title: params.messageTitle || defaultTitle,
        link: params.url || window.location.href,
        imgUrl: params.imgUrl || defaultCover,
        desc: params.desc || '让创新技术推动社会进步'
      })
    })
  },
  isIOS: function () {
    return !!navigator.userAgent.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/)
  }
}
